import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconJourneyLogoGradientRed(props: IconProps) {
  return (
    <BaseIcon viewBox="0 0 144 144" {...props}>
      <g filter="url(#filter0_ddddd_3020_2639)">
        <path
          d="M55.2606 40C59.7706 43.8368 65.615 46.152 72.0002 46.152C78.3854 46.152 84.2298 43.8368 88.7398 40L94.8471 46.1074C88.7654 51.4962 80.7649 54.768 72.0002 54.768C63.2355 54.768 55.2349 51.4962 49.1533 46.1074L55.2606 40Z"
          fill="url(#paint0_linear_3020_2639)"
        />
        <path
          d="M88.7398 104C84.2298 100.163 78.3854 97.848 72.0002 97.848C65.615 97.848 59.7706 100.163 55.2606 104L49.1533 97.8926C55.235 92.5038 63.2355 89.232 72.0002 89.232C80.7649 89.232 88.7655 92.5038 94.8472 97.8926L88.7398 104Z"
          fill="url(#paint1_linear_3020_2639)"
        />
        <path
          d="M40 88.7396C43.8368 84.2296 46.152 78.3852 46.152 72C46.152 65.6148 43.8368 59.7704 40 55.2604L46.1074 49.1531C51.4962 55.2348 54.768 63.2353 54.768 72C54.768 80.7647 51.4962 88.7653 46.1074 94.847L40 88.7396Z"
          fill="url(#paint2_linear_3020_2639)"
        />
        <path
          d="M104 55.2604C100.163 59.7704 97.848 65.6148 97.848 72C97.848 78.3852 100.163 84.2296 104 88.7396L97.8926 94.8469C92.5038 88.7652 89.232 80.7647 89.232 72C89.232 63.2353 92.5038 55.2347 97.8926 49.153L104 55.2604Z"
          fill="url(#paint3_linear_3020_2639)"
        />
      </g>
      <defs>
        <filter
          id="filter0_ddddd_3020_2639"
          x="0"
          y="0"
          width="144"
          height="144"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="20" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.862745 0 0 0 0 0.196078 0 0 0 0 0.196078 0 0 0 0.36 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3020_2639" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="8" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.862745 0 0 0 0 0.196078 0 0 0 0 0.196078 0 0 0 0.26 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_3020_2639"
            result="effect2_dropShadow_3020_2639"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="4" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.862745 0 0 0 0 0.196078 0 0 0 0 0.196078 0 0 0 0.24 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_dropShadow_3020_2639"
            result="effect3_dropShadow_3020_2639"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.862745 0 0 0 0 0.196078 0 0 0 0 0.196078 0 0 0 0.16 0"
          />
          <feBlend
            mode="normal"
            in2="effect3_dropShadow_3020_2639"
            result="effect4_dropShadow_3020_2639"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.862745 0 0 0 0 0.196078 0 0 0 0 0.196078 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="effect4_dropShadow_3020_2639"
            result="effect5_dropShadow_3020_2639"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect5_dropShadow_3020_2639"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_3020_2639"
          x1="40"
          y1="40"
          x2="115.811"
          y2="83.3399"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB5757" />
          <stop offset="1" stopColor="#CB0000" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3020_2639"
          x1="40"
          y1="40"
          x2="115.811"
          y2="83.3399"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB5757" />
          <stop offset="1" stopColor="#CB0000" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3020_2639"
          x1="40"
          y1="40"
          x2="115.811"
          y2="83.3399"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB5757" />
          <stop offset="1" stopColor="#CB0000" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_3020_2639"
          x1="40"
          y1="40"
          x2="115.811"
          y2="83.3399"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB5757" />
          <stop offset="1" stopColor="#CB0000" />
        </linearGradient>
      </defs>
    </BaseIcon>
  );
}
